import React from 'react';
import BlogThree from './BlogThree';

const BlogSectionA = ({ title = "Insights", viewAllLink = "/blog" }) => {
    return (
        <section className="blog pt-0">
            <div className="container">
                {/* BlogOne Component */}
                <BlogThree />
            </div>
        </section>
    );
};

export default BlogSectionA;
